import { createContext } from 'react';
export const ScrollContextState = {
  activeAccentImg: null,
  activeColor: null,
  activeFeatureVideo: null,
  activePosterImage: null,
  activeIndex: 0,
  activeShape: null,
  setActiveAccentImg: () => {
    //noop
  },
  setActiveColor: () => {
    //noop
  },
  setActiveFeatureVideo: () => {
    //noop
  },
  setActivePosterImage: () => {
    //noop
  },
  setActiveIndex: () => {
    //noop
  },
  setActiveShape: () => {
    //noop
  }
};
export const ScrollContext = /*#__PURE__*/createContext(ScrollContextState);